import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {CommunityInfo} from '../model/community-info';
import {ImageListComponent} from '../shared/image-list.component';
import {TourService} from '../services/tour.service';
import {TourApiService} from '../services/tour-api.service';
import {TrackingService} from '../services/tracking.service';
import {AspectRatio, ImageSize} from '../model/image';
import {EnumAware} from '../decorators/enum-aware.decorator';

@Component({
  selector: 'gt-community',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.css']
})
@EnumAware
export class CommunityComponent implements OnInit {
  AspectRatio = AspectRatio;
  ImageSize = ImageSize;
  info: CommunityInfo;
  @ViewChild(ImageListComponent)
  private imageListComponent: ImageListComponent;
  constructor(public apiService: TourApiService, private tourService: TourService, private trackingService: TrackingService) { }

  ngOnInit() {
    this.info = this.tourService.tour.communityInfo;
    this.tourService.setDocumentTitleWithTour(this.tourService.tourFeatureTitle('community'));
    this.trackingService.trackAction(TrackingService.kActionCommunity, null, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/community.component.ts